import React from 'react';
import { SignupLayout, SignupPhoneNumberView } from '../components';
import { useSignupPhoneNumberViewController } from '../controllers';

const SignupPhoneNumberPage: React.FC = () => {
  const {
    numbers,
    totalResults,
    searching,
    appliedFilter,
    openingFilter,
    companyCity,
    areaCodes,
    loadingAreaCodes,
    choosing,
    error,
    chosenNumber,
    chosenHeld,
    continueWithChosen,
    search,
    loadAreaCodes,
    choose,
  } = useSignupPhoneNumberViewController();

  return (
    <SignupLayout scrollsInside>
      <SignupPhoneNumberView
        numbers={numbers}
        totalResults={totalResults}
        searching={searching}
        appliedFilter={appliedFilter}
        openingFilter={openingFilter}
        companyCity={companyCity}
        areaCodes={areaCodes}
        loadingAreaCodes={loadingAreaCodes}
        choosing={choosing}
        error={error}
        chosenNumber={chosenNumber}
        chosenHeld={chosenHeld}
        onSearch={search}
        onLoadAreaCodes={loadAreaCodes}
        onChoose={choose}
        onContinueWithChosen={continueWithChosen}
      />
    </SignupLayout>
  );
};

export default SignupPhoneNumberPage;
